import React, { useState } from "react";
import { CardModal } from "components";
import { Link } from "react-router-dom";
function BookingComplete(props) {
  // const [spaModalShow, setSpaModalShow] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  return (
    <>
      <div className="main my-5">
        <div className="heading">
          <h4>Booking Confirmation</h4>
        </div>
        <div className="text-center mt-3">
          <button
            type="submit"
            className={`button button--effect w-100 
         
            `}
            // disabled={!props.bookNow}
            onClick={() => setModalShow(true)}
          >
            Book Now
          </button>
          {/* <button
            type="submit"
            className={`button button--effect ${bookNow ? "disable-btn" : ""}`}
            onClick={() => setModalShow(true)}
            disabled={bookNow}
          >
            Book Now
          </button> */}
        </div>
      </div>
      <CardModal
        show={modalShow}
        onHide={() => setModalShow(!modalShow)}
        title="Booking Confirmation"
        handleActiveTab={props.handleActiveTab}
      />
    </>
  );
}

export default BookingComplete;
